import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Router, ActivatedRoute } from '@angular/router';
import { ServiceService } from '../../provider/service.service';
import lgVideo from 'lightgallery/plugins/video';
import { BeforeSlideDetail } from 'lightgallery/lg-events';
import { Loader } from "@googlemaps/js-api-loader";
declare var google: any;

@Component({
  selector: 'app-property-details',
  templateUrl: './property-details.component.html',
  styleUrls: ['./property-details.component.scss']
})
export class PropertyDetailsComponent implements OnInit {

	@ViewChild('map') mapElement: ElementRef;

  categoriesSlides: OwlOptions = {
		loop: true,
		nav: true,
		dots: true,
		autoplayHoverPause: true,
		autoplay: true,
		margin: 1,
		navText: [
			"<i class='bx bx-left-arrow-alt'></i>",
			"<i class='bx bx-right-arrow-alt'></i>"
		],
		responsive: {
			0: {
				items: 1
			},
			576: {
				items: 2
			},
			768: {
				items: 3
			},
			1200: {
				items: 4
			}
		}
    }

	userDataPost={"userID":"", "o_companyID":1, "slug":"" };
    constructor(private route: ActivatedRoute, public service: ServiceService) {
		this.userDataPost.slug = this.route.snapshot.paramMap.get('data');
       }

       ngOnInit(): void {
       // console.log(this.userDataPost.categorySlug);
        this.get_property_on_slug();
      }


	pickup_lat:any; pickup_lng:any;  locality:any;
	fslotsData:any; propertySet:any; propertySets:any;  fimgURL:any; fploading:boolean = false;
    get_property_on_slug(){
         this.fploading = true;
         this.service.propertyData(this.userDataPost, 'get_property_on_slug').then((result) => {
           this.fslotsData = result;
           if (this.fslotsData.propertyData){
            this.fploading = false;
         this.propertySets = this.fslotsData.propertyData;
		 if(this.propertySets.length > 0){
			this.propertySet = this.propertySets[0];
			this.propertySet.amenities = JSON.parse(this.propertySet.amenities);
			this.propertySet.facilities = JSON.parse(this.propertySet.facilities);
			this.propertySet.otherRooms  = JSON.parse(this.propertySet.otherRooms);
			this.propertySet.facilitiesCount = this.propertySet.facilities.length;
			this.pickup_lat = this.propertySet.latitude;
			this.pickup_lng = this.propertySet.longitude;
			this.locality = this.propertySet.locality;

			this.show_map(); 
		 }

         this.fimgURL = this.fslotsData.imgURL;
           }else{
          this.fploading = false;
         this.alert('error', 'Opps! Something went wrong. Kindly Contact to Technical Team.');
           }
        }, (err) => { 
        this.fploading = false;
        this.alert('error', 'Opps! Something went wrong. Kindly Contact to Technical Team.'); 
        });
      } 
  
  
  /* Alert Message */
  show_alert:boolean = false; message:any;
  alert(type, message){
    this.show_alert = true;
    this.message={'type':type,'text':message};
    setTimeout(() => {
      this.show_alert = false;
    }, 5000);
  }
  close_alert(){
    this.show_alert = false;
    this.message = '';
  }
  /* End of Alert Message */


  map:any; mapOptions:any;
  show_map(){
	let loader = new Loader({
	  apiKey: "AIzaSyBEINmUz_guyOKSx82wp0s2pAf5pWziDuQ",
	  version: "weekly",
	});
	
	loader.load().then(() => {
	  this.mapOptions = {
		center: { lat: +this.pickup_lat, lng: +this.pickup_lng },
		zoom: 14,
		// disableDefaultUI: true,
		// styles: [{  "elementType": "geometry",  "stylers": [{  "color": "#212121"}  ]},{  "elementType": "labels.icon",  "stylers": [{  "visibility": "off"}  ]},{  "elementType": "labels.text.fill",  "stylers": [{  "color": "#757575"}  ]},{  "elementType": "labels.text.stroke",  "stylers": [{  "color": "#212121"}  ]},{  "featureType": "administrative",  "elementType": "geometry",  "stylers": [{  "color": "#757575"}  ]},{  "featureType": "administrative.country",  "elementType": "labels.text.fill",  "stylers": [{  "color": "#9e9e9e"}  ]},{  "featureType": "administrative.land_parcel",  "stylers": [{  "visibility": "off"}  ]},{  "featureType": "administrative.locality",  "elementType": "labels.text.fill",  "stylers": [{  "color": "#bdbdbd"}  ]},{  "featureType": "poi",  "elementType": "labels.text.fill",  "stylers": [{  "color": "#757575"}  ]},{  "featureType": "poi.park",  "elementType": "geometry",  "stylers": [{  "color": "#181818"}  ]},{  "featureType": "poi.park",  "elementType": "labels.text.fill",  "stylers": [{  "color": "#616161"}  ]},{  "featureType": "poi.park",  "elementType": "labels.text.stroke",  "stylers": [{  "color": "#1b1b1b"}  ]},{  "featureType": "road",  "elementType": "geometry.fill",  "stylers": [{  "color": "#2c2c2c"}  ]},{  "featureType": "road",  "elementType": "labels.text.fill",  "stylers": [{  "color": "#8a8a8a"}  ]},{  "featureType": "road.arterial",  "elementType": "geometry",  "stylers": [{  "color": "#373737"}  ]},{  "featureType": "road.highway",  "elementType": "geometry",  "stylers": [{  "color": "#3c3c3c"}  ]},{  "featureType": "road.highway.controlled_access",  "elementType": "geometry",  "stylers": [{  "color": "#4e4e4e"}  ]},{  "featureType": "road.local",  "elementType": "labels.text.fill",  "stylers": [{  "color": "#616161"}  ]},{  "featureType": "transit",  "elementType": "labels.text.fill",  "stylers": [{  "color": "#757575"}  ]},{  "featureType": "water",  "elementType": "geometry",  "stylers": [{  "color": "#000000"}  ]},{  "featureType": "water",  "elementType": "labels.text.fill",  "stylers": [{  "color": "#3d3d3d"}  ]}]
	  }
	   this.map = new google.maps.Map(document.getElementById("map") as HTMLElement, this.mapOptions); // Generate single Map 
	   this.startPoint_marker(); 
	});
	
  } 

  startPointMarker:any;
startPoint_marker(){
  // let letter = String.fromCharCode("A".charCodeAt(0) + index),
  this.startPointMarker = new google.maps.Marker({
    position: { lat: +this.pickup_lat, lng: +this.pickup_lng }, 
    map: this.map, 
    label: "P",
    // //icon: "http://maps.google.com/mapfiles/marker" + letter + ".png",
    title: this.locality,
  });
}


settings = {
  counter: false,
  plugins: [lgVideo]
};
onBeforeSlide = (detail: BeforeSlideDetail): void => {
  const { index, prevIndex } = detail;
  console.log(index, prevIndex);
};

}
